import FetcherFactory from "../../_shared/Fetcher/factory";
import UserRepository from "./UserRepository";
import StorageFactory from "../../_shared/Storage/factory";

export const userRepository = new UserRepository(
  StorageFactory.encrypterLocalStorage(),
  FetcherFactory.httpFetcher
);

export default userRepository;
